import { DateTime } from 'luxon';

import { ShipmentEvent } from './';

export class ShipmentMilestoneEvent extends ShipmentEvent {
  arriveEventId?: number;
  departEventId?: number;
  actualArrival?: DateTime;

  constructor(opts?: Partial<ShipmentMilestoneEvent>) {
    super(opts);
    if (opts?.arriveEventId != null) {
      this.arriveEventId = opts.arriveEventId;
    }
    if (opts?.departEventId != null) {
      this.departEventId = opts.departEventId;
    }
    if (opts?.actualArrival != null) {
      this.actualArrival = opts.actualArrival;
    }
  }

  get isMilestone(): boolean {
    return true;
  }

  get actualDeparture() {
    return this.actualDate;
  }

  set actualDeparture(actualDeparture: DateTime | undefined) {
    this.actualDate = actualDeparture;
  }

  isResolved(requireBothDate: boolean = false) {
    return !!this.actualDeparture && (!requireBothDate || !!this.actualArrival);
  }
}
